import axios, { AxiosRequestConfig } from 'axios';
import { get, isEmpty, set } from 'lodash';
import moment from 'moment';
import queryString from 'query-string';
import storage from 'utils/sessionStorage';
import toast from 'utils/toast';

const IS_DEV_ENV = true;
// const DOMAIN = 'https://api-digital.bonafideadvisors.net/';
const DOMAIN = 'https://api-digital.fozito.com/';
    
const DEV_DOMAIN_SOCKET = 'https://api-digital.bonafideadvisors.net/api/v1/gs-pos-websocket';
const LIVE_DOMAIN_SOCKET = 'https://api.fozito.com/api/v1/gs-pos-websocket';
export const DOMAIN_SOCKET = IS_DEV_ENV ? DEV_DOMAIN_SOCKET : LIVE_DOMAIN_SOCKET;

const axiosInstance = axios.create({
    baseURL: DOMAIN,
    headers: {
        Accept: 'application/json',
    },
});
export const HeadersParams: {
    userId?: string;
    binId?: string;
} = {};
type mixType = string | number | null | any;

type IFetchArg = {
    method?: 'get' | 'post' | 'delete' | 'put';
    url: string;
    body?: Record<string, mixType | unknown> | FormData;
    params?: Record<string, mixType | Array<mixType>>;
    configs?: AxiosRequestConfig<Record<string, unknown | mixType>> | undefined;
    token?: string;
    shopId?: string;
};
const fetch = async ({
    method = 'get',
    url = '',
    body = {},
    params = {},
    configs = {},
    token: customToken,
    shopId,
}: IFetchArg) => {
    let urlWithParams = url;
    if (!isEmpty(params)) {
        const paramsPasser = queryString.stringify(
            { ...params || {} },
            { arrayFormat: 'bracket' }
        );
        urlWithParams = urlWithParams + '?' + paramsPasser;
    }

    const token = storage.token.get();
    if (token) {
        set(configs, 'headers.Authorization', 'Bearer ' + token);
    }
    if (customToken) {
        set(configs, 'headers.Authorization', 'Bearer ' + customToken);
    }

    const _shopId = shopId || storage.shop_id.get();

    if (_shopId) {
        set(configs, ['headers', 'x-api-key'], _shopId);
    }
    set(configs, ['headers', 'current-date'], moment().format('MM-DD-YYYY HH:mm:ss'));
    
    const getAxios = async () => {
        switch (method) {
            case 'post':
                return await axiosInstance.post(urlWithParams, body, configs);
            case 'put':
                return await axiosInstance.put(urlWithParams, body, configs);
            case 'delete':
                return await axiosInstance.delete(urlWithParams, configs);
            default:
                return await axiosInstance.get(urlWithParams, configs);
        }
    };

    try {
        const res = await getAxios();
        return res;
    } catch (error) {
        const status = get(error, 'response.status');
        if (status === 401 || status === 403) {
            // handle refresh token here
            toast.error('expired token!');
        }
        return Promise.reject(error);
    }
};

export default fetch;
